import { Header } from "@/components/Header";
import { ScrollToTop } from "./ScrollToTop";

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="w-full max-w-screen-2xl mx-auto p-4">{children}</main>
      <ScrollToTop />
    </div>
  );
};